import { clearPrivateRuntimeCaches } from '~/lib/pwa/authCache.mjs';
import type AuthUser from '~/types/authUser';

export const useSwitchCompany = () => {
  async function switchCompany(companyId: string, destination?: string) {
    const { user, fetch: refreshSession } = useUserSession();
    const authUser = user.value as AuthUser | null;

    if (!authUser) {
      throw new Error('User is not authenticated');
    }

    const roles = authUser.roles ?? [];
    const role = roles.find((role) => role.companyId === companyId);

    if (!role) {
      throw new Error('Selected role not found for the given companyId');
    }

    const response = await $fetch('/api/users/authUser', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Accept: 'application/json; charset=utf-8'
      },
      body: {
        companyId: role.companyId,
        roleName: role.roleName
      }
    });

    if (!response) {
      throw new Error('Failed to switch company');
    }

    await clearPrivateRuntimeCaches();
    await refreshSession();

    if (destination) {
      await navigateTo(destination);
    }

    window.location.reload();
  }

  return { switchCompany };
};
